// const Capture = require('@trulioo/globalgateway-image-capture-sdk');

const START_MESSAGE = 'Starting Image Capture';
const TIMEOUT = 30 * 1000; // 30 seconds

// Hint messages can be customized:
// GlobalGatewayHints.GLOBALGATEWAY_ERROR_FOUR_CORNER = "Cannot Find Document";

// Default hint messages
// const GlobalGatewayHints = {
//   GLOBALGATEWAY_HEAD_OUTSIDE: 'Place Face in Oval',
//   GLOBALGATEWAY_HEAD_SKEWED: 'Look Straight Ahead',
//   GLOBALGATEWAY_AXIS_ANGLE: 'Hold Phone Upright',
//   GLOBALGATEWAY_HEAD_TOO_CLOSE: 'Move Farther Away',
//   GLOBALGATEWAY_HEAD_TOO_FAR: 'Get Closer',
//   GLOBALGATEWAY_STAY_STILL: 'Hold Still',
//   GLOBALGATEWAY_STOP_SMILING: 'Stop Smiling',
//   GLOBALGATEWAY_SMILE: 'Smile!',
//   GLOBALGATEWAY_READY_POSE: 'Hold it There',
//   GLOBALGATEWAY_NO_FACE_FOUND: 'No Face Detected',
//   GLOBALGATEWAY_ERROR_GLARE: 'Reduce Glare',
//   GLOBALGATEWAY_ERROR_FOUR_CORNER: 'Not all document corners visible',
//   GLOBALGATEWAY_SUCCESS: 'Success',
//   GLOBALGATEWAY_ERROR_TOO_DARK: 'Too dark. use good lighting',
//   GLOBALGATEWAY_ERROR_FOCUS: 'Hold Steady',
//   GLOBALGATEWAY_ERROR_MRZ_MISSING: 'Passport Not Detected',
//   GLOBALGATEWAY_CV_NO_BARCODE_FOUND: 'No Barcode Detected',
//   GLOBALGATEWAY_ERROR_TOO_FAR: 'Document Too Far',
//   GLOBALGATEWAY_ERROR_TOO_CLOSE: 'Document Too Close',
//   GLOBALGATEWAY_ERROR_NOT_CENTERED: 'Document Not Centered',
//   GLOBALGATEWAY_ERROR_MIN_PADDING: 'Move further away',
//   GLOBALGATEWAY_ERROR_HORIZONTAL_FILL: 'Move closer'
// };

const TYPES = {
  front: 'StartDocumentCapture',
  back: 'StartDocumentCapture',
  live: 'StartSelfieCapture',
  passport: 'StartPassportCapture',
  generic: 'StartGenericDocumentCapture',
};

const ImageCapture = ({
  type,
  onSuccess,
  onError = () => {},
  isAuto = true,
  captureButton = false,
}) => {
  const method = TYPES[type.toLowerCase()];
  if (!method) {
    throw new Error(`Type ${type} is unknown`);
  }
  if (!window[method]) {
    throw new Error(`CaptureImage is not loaded`);
  }

  const errorHandle = errArray => {
    let errorMessage = '';
    if (errArray && errArray.length > 0) {
      // handle different error code here
      for (let i = 0; i < errArray.length; i += 1) {
        errorMessage += `Error Code ${errArray[i].code}: ${errArray[i].type} \n`;
      }
    } else {
      errorMessage = 'Capture timeout';
    }
    if (errorMessage !== '') {
      onError(errorMessage);
    }
  };

  window[method](
    START_MESSAGE,
    TIMEOUT,
    isAuto,
    onSuccess,
    errorHandle,
    isAuto ? captureButton : false, // Capture Button
  );
};

export default ImageCapture;
